<template>
    <div v-if="flag">
        <div class="shop-box">
            <!--   顶部 logo     -->
            <div class="top">
                <div class="logo">
                    <img :src="detail.logo.file_path"/>
                </div>
                <div class="title">
                    <span>{{detail.shop_name}}</span>
                </div>
                <div class="synopsis" v-if="detail.summary">
                    <span>门店简介：{{ detail.summary }}</span>
                </div>
            </div>
            <!--   门店详细信息     -->
            <div class="info-box">
                <div class="text">
                    <span class="title">营业时间：</span>{{detail.shop_hours}}
                </div>
                <div class="text" @click="onOpenLocation">
                    <div class="address">
                        门店地址：<u>{{detail.region.province}}{{detail.region.city}}{{detail.region.region}}{{detail.address}}</u>
                    </div>
                    <div style="float: right;margin-top: -6%;font-size: 20px;display: none"><i class="iconfont icon-jiantou1"></i>
                    </div>
                </div>
                <div class="text">
                    <span class="title">联系电话：</span>{{ detail.phone }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "logout",
        data() {
            return {
                flag: false,
                // 门店详情
                detail: {},
            }
        },
        mounted() { //视图加载完成执行
            let _this = this;
            _this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            _this.getShopDetail(_this.$route.query.shop_id);
        },

        methods: {
            /**
             * 获取门店详情
             */
            getShopDetail(shop_id) {
                let _this = this;
                _this._get('shop/detail', {
                    shop_id: shop_id
                }, function (result) {
                    _this.loading.hide();
                    _this.setData(result.data);
                    _this.flag = true;
                });
            },

            /**
             * 查看位置
             */
            onOpenLocation() {
                let _this = this,
                    detail = _this.detail;
                _this.navigationTo('/order/map', {
                    lat: detail.latitude,
                    long: detail.longitude
                });
            },

        },
    }
</script>

<style lang="scss">
    @import "detail.scss";
</style>
